import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AdminRole } from '@warmancer/shared';

interface AdminState {
  token: string | null;
  role: AdminRole | null;
  setSession: (token: string, role: AdminRole) => void;
  clearSession: () => void;
  isAuthenticated: () => boolean;
  hasRole: (minRole: AdminRole) => boolean;
}

const roleHierarchy: AdminRole[] = ['support', 'mod', 'super'];

export const useAdminStore = create<AdminState>()(
  persist(
    (set, get) => ({
      token: null,
      role: null,

      setSession: (token, role) => {
        set({ token, role });
      },

      clearSession: () => {
        set({ token: null, role: null });
      },

      isAuthenticated: () => {
        return get().token !== null && get().role !== null;
      },

      hasRole: (minRole) => {
        const currentRole = get().role;
        if (!currentRole) return false;

        const currentIndex = roleHierarchy.indexOf(currentRole);
        const minIndex = roleHierarchy.indexOf(minRole);
        return currentIndex >= minIndex;
      },
    }),
    {
      name: 'warmancer-admin',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ token: state.token, role: state.role }),
    }
  )
);
